import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Flag, Video, AlertCircle } from "lucide-react";
import { Link } from 'react-router-dom';
import { useAuth } from "@/context/AuthContext";

interface GameReportAndRequestBoxProps {
  gameId: number;
  gameSlug: string;
  onSuggestVideoClick: () => void;
}

const GameReportAndRequestBox: React.FC<GameReportAndRequestBoxProps> = ({ gameId, gameSlug, onSuggestVideoClick }) => {
  const { isAdmin } = useAuth();
  return (
    <Card className="bg-card text-card-foreground border-border shadow-lg">
      <CardHeader>
        <CardTitle className="text-xl font-bold text-primary flex items-center gap-2">
          <AlertCircle size={20} /> Link küldés
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <p className="text-sm text-muted-foreground mb-2">
          Van egy jó magyar gépi feliratos videód a játékhoz? Itt küld el nekünk!
        </p>
        <Button asChild variant="outline" className="w-full justify-start gap-2">
          {isAdmin && (<Link to={`/games/${gameSlug}/report`}>
            <Flag size={16} /> Hibás adatlap / fordítás jelentése
          </Link>)}
        </Button>
        <Button variant="outline" className="w-full justify-start gap-2" onClick={onSuggestVideoClick}>
          <Video size={16} /> Videó ajánlása
        </Button>
      </CardContent>
    </Card>
  );
};

export default GameReportAndRequestBox;